import { render, staticRenderFns } from "./PanelsPage.vue?vue&type=template&id=e3ffea84&scoped=true"
import script from "./PanelsPage.vue?vue&type=script&lang=js"
export * from "./PanelsPage.vue?vue&type=script&lang=js"
import style0 from "./PanelsPage.vue?vue&type=style&index=0&id=e3ffea84&prod&lang=scss&scoped=true"
import style1 from "./PanelsPage.vue?vue&type=style&index=1&id=e3ffea84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ffea84",
  null
  
)

export default component.exports